module.exports = __webpack_public_path__ + "img/679CCB91AFDE7F9E3903E1BDC1C20141.679ccb91.png";